import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 12,
    minWidth: 440,
    maxWidth: 480,
    width: '100%',
  },

  /* ── Header ── */
  titleRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 20px 14px',
    borderBottom: '1px solid #F3F4F6',
  },
  titleText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#111827',
    lineHeight: 1.4,
  },
  closeBtn: {
    padding: 6,
    color: '#9CA3AF',
    '&:hover': {
      color: '#374151',
      backgroundColor: 'rgba(0,0,0,0.04)',
    },
  },

  /* ── Body ── */
  content: {
    padding: '20px 20px 8px',
  },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: '#374151',
    marginBottom: 6,
  },
  hint: {
    fontSize: 11.5,
    color: '#9CA3AF',
    marginTop: 6,
  },

  /* Input override */
  inputRoot: {
    borderRadius: 8,
    fontSize: 13.5,
    '& fieldset': {
      borderColor: '#E5E7EB',
      borderRadius: 8,
    },
    '&:hover fieldset': {
      borderColor: '#D1D5DB',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#22C55E !important',
      boxShadow: '0 0 0 3px rgba(34,197,94,0.12)',
    },
  },

  /* ── Footer ── */
  actions: {
    padding: '14px 20px 18px',
    gap: 10,
    justifyContent: 'flex-end',
  },
  btnCancel: {
    borderRadius: 8,
    padding: '7px 18px',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'none',
    color: '#374151',
    border: '1px solid #E5E7EB',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#F9FAFB',
      borderColor: '#D1D5DB',
    },
  },
  btnSave: {
    borderRadius: 8,
    padding: '7px 20px',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#22C55E',
    border: '1px solid #22C55E',
    '&:hover': {
      backgroundColor: '#16A34A',
      borderColor: '#16A34A',
    },
    '&.Mui-disabled': {
      backgroundColor: '#BBF7D0',
      borderColor: '#BBF7D0',
      color: '#fff',
    },
  },
}))

const RenameTagModal = ({ open, handleClose, handleSubmit, renameSelected }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [val, setVal] = useState(renameSelected?.name || '')

  const trimmed = val.trim()
  const disabled = !trimmed

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
      disableBackdropClick={false}
    >
      {/* ── Header ── */}
      <DialogTitle disableTypography className={classes.titleRoot}>
        <span className={classes.titleText}>{t('setting_account.rename_tag_title')}</span>
        <IconButton className={classes.closeBtn} onClick={handleClose} size="small">
          <X size={16} />
        </IconButton>
      </DialogTitle>

      {/* ── Body ── */}
      <DialogContent className={classes.content}>
        <div className={classes.label}>{t('setting_account.rename_tag_new_name_label')}</div>
        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          size="small"
          placeholder={t('setting_account.rename_tag_placeholder')}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !disabled) {
              handleSubmit(renameSelected, trimmed)
            }
          }}
          InputProps={{ classes: { root: classes.inputRoot } }}
          inputProps={{ maxLength: 50 }}
        />
        <div className={classes.hint}>
          {t('setting_account.rename_tag_hint')}
        </div>
      </DialogContent>

      {/* ── Footer ── */}
      <DialogActions className={classes.actions}>
        <Button className={classes.btnCancel} onClick={handleClose}>
          {t('setting_account.rename_tag_cancel')}
        </Button>
        <Button
          className={classes.btnSave}
          disabled={disabled}
          onClick={() => handleSubmit(renameSelected, trimmed)}
        >
          {t('setting_account.rename_tag_save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RenameTagModal
